import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { HomecardLabel, Checked } from '@spotahome/ui-library';
import { trans } from '@spotahome/bff/client';

import './HomeCardLabels.scss';

const HomeCardLabels = ({ checked, isNew }) => (
  <Fragment>
    {checked && (
      <HomecardLabel
        renderIcon={() => <Checked />}
        renderContent={() => trans('homecard.label.checked')}
        className="label--checked"
      />
    )}
  </Fragment>
);

HomeCardLabels.propTypes = {
  checked: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired
};

export const generateHomeCardLabels = ({ checked, isNew }) => () => (
  <HomeCardLabels checked={checked} isNew={isNew} />
);

export default generateHomeCardLabels;
